import { Component } from '@angular/core';

@Component({
  selector: 'app-shared-vert-bar',
  templateUrl: './shared-vert-bar.component.html',
  styleUrls: ['./shared-vert-bar.component.scss']
})
export class SharedVertBarComponent {

}
